import { useQuery } from '@tanstack/react-query';

import { formatDateToISO, normalizeToStartOfDayUTC } from '@/utils/date-formatters';
import { normalizeToEndOfDayUTC } from '@/utils/date-formatters/date-formatters';

import { getWorklogsSummary } from '../api/time-tracking.api';
import { TIME_TRACKING_QUERY_KEYS } from '../constants/time-tracking-query-keys';
import { ViewMode } from '../types/time-tracking';
import { getDateRangeForView } from './use-view-mode-and-date';

interface UseSummaryParams {
  date: Date;
  viewMode: ViewMode;
}

export const useSummary = ({ date, viewMode }: UseSummaryParams) => {
  const { start, end } = getDateRangeForView(date, viewMode);
  const startDate = formatDateToISO(normalizeToStartOfDayUTC(start));
  const endDate = formatDateToISO(normalizeToEndOfDayUTC(end));

  return useQuery({
    queryKey: TIME_TRACKING_QUERY_KEYS.summary(startDate, endDate),
    queryFn: () => getWorklogsSummary(startDate, endDate),
    staleTime: 1000 * 60 * 5,
  });
};
